export default "__VITE_ASSET__BEZOAY8r__";